/**
 * 自定义导航（definePage style.navigationStyle: 'custom'）尺寸换算
 *
 * 布局模型：整条自定义导航 = 状态栏 + 导航条，其中导航条与微信胶囊按钮等高
 * 且让胶囊垂直居中（上下间距 = 胶囊 top - 状态栏高度）。
 * 导出值默认单位为 rpx，页面里可直接拼进 style（如 `${navHeight}rpx`）；
 * 带 Px 后缀的为 px 值（如 navTopPx，fixed 定位偏移用）。
 *
 * 说明：
 * - 各值在模块加载时基于系统信息一次性算好（设备信息运行期不会变化），直接引用即可；
 * - uni.getMenuButtonBoundingClientRect 仅小程序端可用；h5 端（src/pages-h5，用 uni 内置标题栏、不走
 *   自定义导航）没有胶囊，但本模块经 @/utils 桶文件被无条件引入，必须在 h5 下可求值，故给一组兜底值。
 */
import { isH5 } from './platform'

/** 系统信息（屏幕宽度、状态栏高度等，单位 px） */
const systemInfo = uni.getSystemInfoSync()

/** 状态栏高度（px） */
const statusBarHeightPx = systemInfo.statusBarHeight ?? 0

/** 微信胶囊按钮的布局位置信息（top / height 等，单位 px）；h5 无胶囊，按「导航条 44px、紧贴状态栏」兜底 */
const menuButtonInfo = isH5
  ? { top: statusBarHeightPx, height: 44 }
  : uni.getMenuButtonBoundingClientRect()

/**
 * 导航条高度（px，不含状态栏）
 * = 胶囊高度 + 胶囊与状态栏的间距 * 2，保证胶囊在导航条内垂直居中
 */
const navBarHeightPx
  = menuButtonInfo.height + (menuButtonInfo.top - statusBarHeightPx) * 2

/** px → rpx 换算系数（rpx 规范：任意设备屏幕宽度恒等于 750rpx），兜底按 375px 屏宽算 */
export const pxToRpx = 750 / (systemInfo.screenWidth || 375)

/** 状态栏高度（rpx） */
export const statusBarHeight = statusBarHeightPx * pxToRpx

/** 导航条高度（rpx，不含状态栏），计算模型见 navBarHeightPx */
export const navHeight = navBarHeightPx * pxToRpx

/** 自定义导航整体高度（rpx）= 状态栏 + 导航条，常用作页面内容的顶部偏移（padding-top） */
export const navTop = statusBarHeight + navHeight

/** 自定义导航整体高度（px）= 状态栏 + 导航条，fixed 定位偏移等 px 场景用（如筛选条吸顶） */
export const navTopPx = statusBarHeightPx + navBarHeightPx
